import { useQuery } from '@apollo/client';

import { PROFILE_QUERY } from '@/gql/queries/user/user.query.gql';
import { hasElevatedRights } from '@/utils/privileges';

export const useUser = () => {
  const { data, loading, error } = useQuery(PROFILE_QUERY, {
    fetchPolicy: 'cache-first',
    context: {}
  });

  return {
    user: data?.me,
    isPrivileged: hasElevatedRights(data?.me),
    loading,
    error
  };
};
